import { ReactNode } from "react";

/**
 * Tarjeta KPI del Dashboard de Puntos: card blanca con borde sobre la card de la página,
 * rótulo chico arriba y el número grande abajo. §3.3: rótulo en Body Small de label
 * (13px/600) y número en el tamaño H2 (25px) con peso regular. Sin `description` no se
 * reserva el renglón de la bajada.
 */
export const PointMetricsKpiCard = ({
  label,
  value,
  description,
  columnClassName,
}: {
  label: string;
  value: ReactNode;
  description?: string;
  columnClassName: string;
}) => (
  <div className={columnClassName}>
    <div
      className="surface-card border-1 surface-border h-full flex flex-column"
      style={{
        borderRadius: "var(--radius-lg)",
        padding: "var(--space-16) var(--space-18)",
        gap: "var(--space-12)",
      }}
    >
      <span
        className="text-700"
        style={{
          fontSize: "var(--font-small-size)",
          fontWeight: "var(--font-small-label-weight)",
          lineHeight: "var(--font-small-line)",
        }}
      >
        {label}
      </span>
      <div
        className="text-900 mt-auto"
        style={{
          fontSize: "var(--font-h2-size)",
          fontWeight: "var(--font-body-weight)",
          lineHeight: "var(--font-h2-line)",
        }}
      >
        {value}
      </div>
      {description && (
        <small className="text-color-secondary block" style={{ minHeight: "2.5rem" }}>
          {description}
        </small>
      )}
    </div>
  </div>
);
